// realtime/LayoutChart/33.jsx
import { useState, useEffect } from 'react';
import LayoutGrid from './LayoutGrid';
import ChartPanel from './ChartPanel';
import { useFetchingData } from '../../../components/api.js';

export default function Layout33() {
  const { __fetching_data__ } = useFetchingData();
  const [symbols, setSymbols] = useState(Array(9).fill(null));
  const [options, setOptions] = useState([]);
  const baseApiUrl = process.env.NODE_ENV === 'production'
    ? (window.location.protocol==='https:' 
        ? process.env.REACT_APP_API_HTTPS_URL 
        : process.env.REACT_APP_API_HTTP_URL)
    : '/application';

  useEffect(() => {
    __fetching_data__({ url:`${baseApiUrl}/realtime_symbols` })
      .then(r=>setOptions(r.data.symbols))
      .catch(console.error);
  }, []);

  return (
    <LayoutGrid columns={3} gap={1}>
      {symbols.map((sym,i) => (
        <ChartPanel
          key={i}
          symbol={sym}
          symbolsList={options}
          baseApiUrl={baseApiUrl}
          onSymbolChange={v => {
            setSymbols(s => { const c=[...s]; c[i]=v; return c; });
          }}
        />
      ))}
    </LayoutGrid>
  );
}
